import { TagsInput, TagsOutput } from "../interfaces";
import { BaseService } from "./BaseService";

export class TagsService extends BaseService<TagsInput, TagsOutput> {
  constructor() {
    super();
    this.path = "tags";
  }
}
